module.exports = __webpack_public_path__ + "static/headshot-447ed6b55504ec6ec517dbcb6d09cf29.jpg";